import { Link } from "react-router-dom";
const AdminTabs = (props) => {
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item">
        <Link
          to={"/companieslist"}
          className={
            props.pageName === "COMPANIES"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          COMPANIES
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to={"/agentlist"}
          className={
            props.pageName === "AGENTS"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          AGENTS
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to={"/supplierlist"}
          className={
            props.pageName === "SUPPLIERS"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          SUPPLIERS
        </Link>
      </li>

      <li className="nav-item" role="presentation">
        <Link
          to={"/suppliervisaprice"}
          className={
            props.pageName === "SUPPLIER PRICE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          SUPPLIER PRICE
        </Link>
      </li>
      {/* <li className="nav-item" role="presentation">
                    <Link to={"/agent/payments"} className={props.pageName === "PAYMENTS" ? "nav-link active bg-primary text-white" : "nav-link"}>PAYMENTS</Link>
                </li>
                 <li className="nav-item" role="presentation">
                    <Link to={"/agent/credits"} className={props.pageName === "CREDIT" ? "nav-link active bg-primary text-white" : "nav-link"}>CREDIT HISTORY</Link>
                </li>
                <li className="nav-item" role="presentation">
                    <Link to={"/agent/invoices"} className={props.pageName === "INVOICE" ? "nav-link active bg-primary text-white" : "nav-link"}>INVOICES</Link>
                </li> */}
    </ul>
  );
};

export default AdminTabs;
